import React from "react";
import "./../assets/css/Footer.css";
import logvefase from "./../assets/banner/logo-negro.webp"; // Ajusta la ruta según sea necesario
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-jm">
      <div className="footer-container-jm">
        <div className="row">
          <div className="col-md-1 col-sm-12">
            
          </div>
          <div className="col-md-2 col-sm-12">
            <div className="footer-column">
              <img src={logvefase} 
              alt="Logo" 
              className="footer-logo" 
              style={{
                    width: "70%",
                    height: "100%"
                  }}
              />
            </div>
          </div>
       
          <div className="col-md-3 col-sm-12">
            <div className="footer-column">
              <h3 className="mb-4">Información</h3>
              <p> <Link to="/nosotros">Sobre Nosotros</Link></p> 
              <p><Link to="/comunidad">Comunidad</Link></p>
              
              <p><Link to="/noticias">Blog</Link></p>
            </div>
          </div>
          <div className="col-md-3 col-sm-12">
            <div className="footer-column">
              <h3 className="mb-4">Servicio al Cliente</h3>
              <p><Link to="/servicios">Servicios</Link></p>
              <p><Link to="/productos">Productos</Link></p>
              <p><Link to="/servicios">Libro de reclamaciones</Link></p>
            </div>
          </div>
          
          <div className="col-md-3 col-sm-12">
            <div className="footer-column">
            <h3 className="mb-4">Contacto</h3>
            <p style={{ fontSize: "17px" }}>habitatinclusion@gmail.com</p>
              <p>+51 993925008</p>
              <p>+51 973946104</p>
              <p>Lima-Peru</p>
              
            </div>
          </div>
          <div className="col-md-2 col-sm-12">
            
            </div>
          <div className="col-md-12 col-sm-12 text-center mt-5">
          <p>
                &copy; 2025 Habitatinclusion. Todos los derechos reservados. Diseñado por Asismarka
            
              </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
